<template>
  <section id="lm-process-actions">
    <div class="row">
      <div class="col-12">
        <h4>Crear Trámites de este tipo</h4>
        <p>Seleccione que usuarios pueden crear trámites de este tipo. Puede seleccionar los que pertenezcan a un Área o Subárea, o los usuarios con determinado Rol.</p>
        <p>Si no selecciona nada, todos los usuarios de todas las áreas van a poder crear este tipo de trámites.</p>
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  :disabled="disabled"
                  class="mr-4"
                  label="Áreas"
                  clearable
                  pathToGetOptions="/customer/areas"
                  v-model="actionsData.area"
                  @input="clearSubAreas"
                />
                <LmButton
                  :disabled="!actionsData.area"
                  buttonClass="btn-primary"
                  @click="onAdd('area')"
                  :value="$t('add')"
                />
              </div>
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  class="mr-4"
                  :disabled="!(!!actionsData.area) || disabled"
                  label="Subáreas"
                  clearable
                  :pathToGetOptions="subareaOptions"
                  v-model="actionsData.subarea"
                />
                <LmButton
                  :disabled="!actionsData.subarea"
                  buttonClass="btn-primary"
                  @click="onAdd('subarea')"
                  :value="$t('add')"
                />
              </div>
            </div>
          </div>

          <div class="col-6">
              <b-list-group v-if="actions.length">
                <b-list-group-item v-for="(item, index) of actions" :key="index">
                  <div class="d-flex align-items-center justify-space-between">
                    <div class="d-flex align-items-center w-50">
                      <i
                        style="font-size: 20px"
                        class="mr-2 mdi"
                        :class="`mdi-${item.icon}`"
                      />
                      <span>
                        {{ item.name }}
                      </span>
                    </div>
                    <div class="d-flex justify-content-end align-items-center w-50">
                      <div>
                        <LmTreeSelect
                          :disabled="disabled"
                          clearable
                          pathToGetOptions="/customer/roles"
                          v-model="item.role"
                          placeholder="Todos los roles"
                          class="role-select"
                          @input="onSetRoleAction(item.id, item.group, index)"
                        />
                      </div>
                      <b-dropdown variant="text" boundary="viewport" :disabled="disabled">
                        <template #button-content>
                          <i class="mdi mr-1" :class="item.action === 'S' ? 'mdi-play-outline' : 'mdi-replay'"></i>
                          {{ item.action === 'S' ? 'Iniciar' : 'Solicita iniciar' }}
                        </template>
                        <b-dropdown-item-button @click="onSetStartAction(item.id, item.group)">
                          <i class="mdi mdi-play-outline mr-1"></i>
                          Inicia
                        </b-dropdown-item-button>
                        <b-dropdown-item-button @click="onSetRequestStartAction(item.id, item.group)">
                          <i class="mdi mdi-replay mr-1"></i>
                          Solicita iniciar
                        </b-dropdown-item-button>
                      </b-dropdown>
                      <i
                        v-if="!disabled"
                        style="font-size: 20px"
                        class="mx-2 clickable mdi mdi-close"
                        @click="onDelete(item)"
                      />
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div v-else>
                <LmSvgIcon
                  icon="LmNoDataIcon"
                  width="7.5em"
                  wrapperClass="mb-4 d-flex justify-content-center"
                />
                <p class="text-center">
                  Todavía no se han seleccionado permisos para los trámites.
                </p>
              </div>
          </div>

        </div>
      </div>
    </div>
    <!-- <b-row>
      <b-col md="3">
        <h4>Editar Trámites de este tipo</h4>
        <p>Indique a dónde deben pertenecer los usuarios que pueden editar trámites de este tipo.</p>
        <LmRadio
          v-model="editAction"
          name="numerator"
          label="¿Quiénes pueden tomar el trámite?"
          isVertical
          :help="$t('numerator_type_help')"
          :options="[
            {text: 'Área del destinatario', value: 'destinationArea'},
            {text: 'Subárea del destinatario', value: 'destinationSubarea'},
            {text: 'Otra área', value: 'externalArea'}
          ]"
        />
        <LmTreeSelect
          v-if="editAction === 'externalArea'"
          v-model="editActionDetail"
          label="Seleccione las áreas"
          pathToGetOptions="/customer/areas"
          multiple
        />
      </b-col>
    </b-row> -->
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmRadio from '@/components/form/elements/LmRadio'
import LmButton from '@/components/form/elements/LmButton'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmRadio,
    LmButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      actionsData: {
        area: null,
        subarea: null
      },
      editAction: 'destinationArea',
      editActionDetail: null
    }
  },
  computed: {
    actions () {
      let items = []
      for (const key in this.value) {
        const arr = this.value[key].map(el => {
          return {
            ...el,
            group: key,
            icon: this.setIcon(key)
          }
        })
        items = items.concat(arr)
      }
      return items
    },
    subareaOptions () {
      if (this.actionsData?.area?.id) {
        return `/customer/subareas/${this.actionsData?.area?.id}`
      }
      return null
    }
  },
  methods: {
    setIcon (type) {
      const icons = {
        area: 'domain',
        subarea: 'account-group'
      }
      return icons[type]
    },
    clearData (prop) {
      this.actionsData[prop] = null
    },
    onDelete (item) {
      this.value[item.group] = this.value[item.group].filter(el => el.id !== item.id)
    },
    onAdd (type) {
      if (this.value[type].some(val => val.id === this.actionsData[type].id)) {
        this.clearData(type)
        this.lmToastDangerMessage('No se agregaron los privilegios duplicados.', 'Destinatario duplicado')
        return
      }
      this.value[type].push({
        ...this.actionsData[type],
        action: 'S',
        role: null
      })
      this.clearData(type)
    },
    clearSubAreas () {
      if (this.actionsData.subareas) {
        this.actionsData.subarea = null
      }
    },
    onSetStartAction (id, group) {
      this.value[group].find(el => el.id === id).action = 'S'
    },
    onSetRequestStartAction (id, group) {
      this.value[group].find(el => el.id === id).action = 'RS'
    },
    onSetRoleAction (id, group, index) {
      this.value[group].find(el => el.id === id).role = this.actions[index].role
    }
  },
  mounted () {
    // Creamos un watcher para limpiar la subarea cuando se cambia el area
    this.$watch('actionsData.area', _ => {
      this.actionsData.subarea = null
    })
  }
}
</script>

<style lang="sass">
#lm-process-actions
  .btn.dropdown-toggle:focus
    outline: none
    box-shadow: none
  .role-select
    margin-bottom: 0px !important
</style>
